import React, { useMemo, useEffect, useCallback, useState } from 'react';

import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';
import { BoxInstitution, Container } from './styles';
import api from '~/services/api';

const Breadcumbs = ({ path, pathTitle, routeId }) => {
  const currentUrl = window.location.pathname;

  const { roles } = useSelector(state => state.auth);
  const { instituitionData } = useSelector(state => state.instituitions);

  const [data, setData] = useState(null);

  const ROLE_ADMIN = useMemo(() => {
    return roles?.includes('ROLE_ADMIN');
  }, [roles]);

  const getInstituitionData = useCallback(async id => {
    try {
      const response = await api.get(`/instituicoes/${id}`);

      setData(response.data);
    } catch (err) {
      //
    }
  }, []);

  useEffect(() => {
    if (ROLE_ADMIN && routeId) {
      getInstituitionData(routeId);
    }
  }, [routeId]);

  return (
    <Container>
      <ul>
        <li>
          <a href="/">Principal</a>
        </li>

        {path === 'enviar-indicadores-gerais' && (
          <li>
            <a href={path}>Envio de dados</a>
          </li>
        )}
        {currentUrl.includes('/administrador') && (
          <li>
            <a href={path}>Administrador</a>
          </li>
        )}
        {currentUrl.includes('/adicionar-nova-instituicao') && (
          <li>
            <a href="/instituicoes-participantes">Instituições participantes</a>
          </li>
        )}

        {currentUrl.includes('/resumo-de-eventos') && (
          <li>
            <a href="/registros-de-operacoes">Registro de Operações</a>
          </li>
        )}

        {path && (
          <li>
            <a href={path}>{pathTitle}</a>
          </li>
        )}
      </ul>
      {!ROLE_ADMIN && currentUrl !== '/' && instituitionData && (
        <BoxInstitution>
          <p>{instituitionData?.nomeFantasia}</p>
          <span>
            <strong>CNES:</strong> {instituitionData?.cnes}
          </span>
        </BoxInstitution>
      )}

      {ROLE_ADMIN && currentUrl !== '/' && data && (
        <BoxInstitution>
          <p>{data?.nomeFantasia}</p>
          <span>
            <strong>CNES:</strong> {data?.cnes}
          </span>
        </BoxInstitution>
      )}
    </Container>
  );
};

Breadcumbs.propTypes = {
  path: PropTypes.string.isRequired,
  pathTitle: PropTypes.string.isRequired,
};

export default Breadcumbs;
export { Breadcumbs };
